export interface IFormField {
  // TODO: This should be in a UI-related package
  readonly hide?: boolean;
  readonly required?: boolean;
}
